import { render, staticRenderFns } from "./FightReportDuel.vue?vue&type=template&id=739d9e3f&scoped=true"
import script from "./FightReportDuel.vue?vue&type=script&lang=js"
export * from "./FightReportDuel.vue?vue&type=script&lang=js"
import style0 from "./FightReportDuel.vue?vue&type=style&index=0&id=739d9e3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739d9e3f",
  null
  
)

export default component.exports